/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {KTIcon} from '../../../helpers'
import { useAuth } from '../../../../app/modules/auth'
import { BLACKBOXES_BLACKBOX_TABLE_GRAPHIC_GET_TOTAL_CAR_TIME, BLACKBOXES_BLACKBOX_TABLE_GRAPHIC_GET_URL, BLACKBOXES_BLACKBOX_TABLE_GRAPHIC_URL, BLACKBOXES_GET_CANIOLABEL, BLACKBOXES_GET_LIST_SIZE_URL } from '../../../../urls'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string
  deviceList:any
}

const CarSumMovement: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  titleColor,
  description,
  descriptionColor,
  deviceList
}) => {
  
  const {currentUser, logout} = useAuth()
  const token = currentUser?.token
  // Kart uc durumu AYIRT EDIYOR: yukleniyor / deger / bilinmiyor.
  //
  // Eskiden state `useState(0)` ile basliyordu ve hata durumunda degismiyordu; isNumber(0)
  // true oldugu icin ekranda "0 sa 0 dk" yaziyordu -- yani gercek bir olcum gibi gorunen
  // yanlis bir deger. Bozuk oldugu belli olmuyordu. 2026-10-07 pano gezintisi.
  const [toalCarTime, setTotalCarTime] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)
  const carTimeList:number[] = []
  const createHeader = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', "" + token?.toString());
    return headers
}

  useEffect(() => {
    getCarTime()
  },[deviceList]) 

  async function getCarTime() {
    // try/catch eskiden YOKTU ve 401 bile kontrol edilmiyordu.
    try {
      const response = await fetch(BLACKBOXES_BLACKBOX_TABLE_GRAPHIC_GET_TOTAL_CAR_TIME + `?role=${currentUser?.role}&id=${currentUser?.id}`, {
          method: "GET",
          headers: createHeader(),
      })
      if (response.status === 401) {
        logout();
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }
      const data = await response.json()
      setTotalCarTime(typeof data === 'number' ? data : null)
    } catch (error) {
      console.error("Toplam araba hareket suresi alinamadi:", error);
      setTotalCarTime(null)
    } finally {
      setLoading(false)
    }
   }
    


  function isNumber(value) {
    return typeof value === 'number';
  }
  function totalFormatTime(craneFirstAxis) {
    const date = new Date(craneFirstAxis * 1000); // Saniyeleri milisaniyelere çevirme
    
    const totalDate = date.getTime() 
    const resultDate = new Date(totalDate);

    const hours = resultDate.getUTCHours();
    const minutes = resultDate.getUTCMinutes();
    const remainingSeconds = resultDate.getUTCSeconds();

    
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    return formattedTime;
}
  return (
    <a href='#' className={`card bg-${color} hoverable ${className}`}>
      <div className='card-body'>
        <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1`} />

        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>Toplam Araba hareket süresi : 
         {loading ? "yükleniyor…" : isNumber(toalCarTime) ? totalFormatTime(toalCarTime)  : "bilinmiyor"} 
        </div>

        <div className={`fw-semibold text-${descriptionColor}`}>Tüm vinç araba hareket sürelerinin toplamı</div>
      </div>
    </a>
  )
}

export {CarSumMovement}
